import { apiClient, unwrap } from './client';
import type { ApiResponse } from '@/types/api';

export interface JobsStatsDto {
  enqueued: number;
  processing: number;
  succeeded: number;
  failed: number;
  scheduled: number;
  retries: number;
  servers: number;
}

export interface JobItemDto {
  id: string;
  state: string;
  jobName?: string | null;
  arguments?: string | null;
  createdAt?: string | null;
  stateChangedAt?: string | null;
  reason?: string | null;
  server?: string | null;
  exceptionMessage?: string | null;
}

export interface JobsListRequest {
  state: 'succeeded' | 'failed' | 'processing' | 'enqueued' | 'scheduled';
  page?: number;
  pageSize?: number;
}

export interface JobsListResultDto {
  state: string;
  total: number;
  items: JobItemDto[];
}

export const jobsApi = {
  getStats(): Promise<JobsStatsDto> {
    return unwrap(apiClient.get<ApiResponse<JobsStatsDto>>('/jobs/stats'));
  },
  list(request: JobsListRequest): Promise<JobsListResultDto> {
    return unwrap(apiClient.get<ApiResponse<JobsListResultDto>>('/jobs', { params: request }));
  },
  requeue(id: string): Promise<void> {
    return apiClient.post(`/jobs/${id}/requeue`).then(() => undefined);
  },
  delete(id: string): Promise<void> {
    return apiClient.delete(`/jobs/${id}`).then(() => undefined);
  },
};
